export default __webpack_public_path__ + "static/media/2.e47f9ecf.png";